import React, { FC, memo } from "react";

import { ContainerChildren } from "../components/ContainerChildren/ContainerChildren";
import { ExpandableTitle } from "../components/ExpandableTitle/ExpandableTitle";
import { Container } from "./styled";
import { useWidgetContext } from "../../Dashboard/hooks/useWidgetContext";
import { isVisibleContainer } from "../utils/isVisibleContainer";
import { ContainerProps } from "../types";

export const ContainersGroupContainer: FC<ContainerProps> = memo(({ config, elementConfig, type, renderElement }) => {
  const { expandedContainers } = useWidgetContext(type);
  const { options, children, style } = elementConfig || config || {};
  const { column, expandable, expanded } = options || {};
  const isColumn = column === undefined || column;
  const isMain = !!elementConfig?.id;

  const isVisible = isVisibleContainer(elementConfig?.id, expandable, expanded, expandedContainers);

  return (
    <>
      <ExpandableTitle elementConfig={elementConfig} type={type} renderElement={renderElement} />
      {isVisible && (
        <Container style={style} isColumn={isColumn} isMain={isMain}>
          <ContainerChildren items={children} isColumn={isColumn} isMain={isMain} renderElement={renderElement} />
        </Container>
      )}
    </>
  );
});
